import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D_Other() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    // UK属于英规
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es', 'cis', 'nl'];
    // 本地化图片
    const LOCAL_SITES: string[] = ['za', 'kr'];
    return (
        <div id="outdoor-recreation-D" className={`outdoor-recreation-D ${css['outdoor-recreation-D']}`}>
            <div className="img-box">
                <EFPicture
                    src={`/responsive/picture/outdoor-recreation/4${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                    srcDesktop={`/responsive/picture/outdoor-recreation/4_1366${
                        EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''
                    }.jpg`}
                    srcPad={`/responsive/picture/outdoor-recreation/4_768${
                        EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''
                    }.jpg`}
                    srcMobile={`/responsive/picture/outdoor-recreation/4_375${
                        EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES.includes(locale) ? `_${locale}` : ''
                    }.jpg`}
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <div className="tags">
                        <span className="tag">{t('secD_tag1')}</span>
                        <span className="tag">{t('secD_tag2')}</span>
                        <span className="tag">{t('secD_tag3')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
